// StarAPI wraps Instagram's own answer in { status, response: { status_code, body } }. On a refusal the body is
// often a JSON *string* ('{"message": "Not authorized to view user", "status": "fail"}' for a private account),
// which the old `body.status` read turned into "Unknown error". This pulls out the real reason for the error text.

/** Human-readable reason for a non-200 StarAPI answer, e.g. "400 Not authorized to view user". */
export function starApiFailureReason(data: unknown): string {
    const d = (data && typeof data === "object" ? data : {}) as { message?: unknown; status?: unknown; response?: { status_code?: unknown; body?: unknown } }
    const code = typeof d.response?.status_code === "number" ? d.response.status_code : undefined
    let body = d.response?.body
    if (typeof body === "string") {
        try {
            body = JSON.parse(body)
        } catch {
            // Not JSON (an HTML error page): no usable message in it.
            body = undefined
        }
    }
    const b = (body && typeof body === "object" ? body : {}) as { message?: unknown; status?: unknown }
    const message = [b.message, d.message].find((v): v is string => typeof v === "string" && v.trim().length > 0)
    // d.status is the wrapper's own "done"/"error", never the reason; only the body's status is.
    const status = typeof b.status === "string" && b.status.trim() ? b.status : undefined
    const reason = message ?? status ?? "Unknown error"
    return code !== undefined ? `${code} ${reason}` : reason
}
